import { QueryClient, useQuery, useMutation } from '@tanstack/react-query'

import useGeneralAbsencesService from './useGeneralAbsencesService'

export const useGetGeneralAbsenceListQuery = () => {
  return useQuery({
    queryKey: ['general-absences'],
    queryFn: useGeneralAbsencesService.getList,
  })
}

export const useGetGeneralAbsenceCalendarDataQuery = (startsAt: string, endsAt: string) => { 
  return useQuery({
    queryKey: ['calendar-general-absences', startsAt, endsAt],
    queryFn: () => useGeneralAbsencesService.getCalendarData(startsAt, endsAt),
    enabled: false
  })
}

export const useGetGeneralAbsenceQuery = (generalAbsenceUuid: string) => {
  return useQuery({
    queryKey: ['general-absences', generalAbsenceUuid],
    queryFn: ({ queryKey }) =>
      useGeneralAbsencesService.getGeneralAbsence(queryKey[1]),
  })
}

export const usePostGeneralAbsenceMutation = (queryClient: QueryClient) => {
  return useMutation({
    mutationFn: useGeneralAbsencesService.createGeneralAbsence,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['general-absences'] })
    },
  })
}

export const usePutGeneralAbsenceMutation = (queryClient: QueryClient) => {
  return useMutation({
    mutationFn: useGeneralAbsencesService.updateGeneralAbsence,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['general-absences'] })
    },
  })
}

export const useDeleteGeneralAbsenceMutation = (queryClient: QueryClient) => {
  return useMutation({
    mutationFn: useGeneralAbsencesService.deleteGeneralAbsence,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['general-absences'] })
    },
  })
}
